import { getNumber, getJson, numConvert } from "../../../../method";

export function compute(data) {

   
    return data
}




// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/price/1.1/compute.js